import "./App.css";
import Rutas from "./router/App.Routes";
import Footer from "./components/Footer/Footer";
import NavBar from "./components/NavBar/NavBar";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider } from "./context/context";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";

function App() {
  return (
    <Router
      basename={process.env.NODE_ENV === "development" ? "/" : "/tramites"}
    >
      <AppProvider>
        <div className="appContainer">
          <NavBar />
          <div className="contentWrapper">
            <ErrorBoundary>
              <Rutas />
            </ErrorBoundary>
          </div>
          <Footer />
        </div>
      </AppProvider>
    </Router>
  );
}
export default App;
